import { useSyncExternalStore } from 'react';
import { getLegKickUiSnapshot, subscribeLegKickUi } from '../../state/legKickUiStore.ts';
import { LEG_KICK_DOM } from './legKickDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function LegKickHud() {
  const d = LEG_KICK_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(
    subscribeLegKickUi,
    getLegKickUiSnapshot,
    getLegKickUiSnapshot,
  );

  const MODE_LABELS: Record<'CLASSIC' | 'ARCADE' | 'ZEN', string> = {
    CLASSIC: t('game.classic'),
    ARCADE: t('game.arcade'),
    ZEN: t('game.zen'),
  };

  const hearts =
    s.lives !== null
      ? (() => {
        const maxLives = 3;
        const L = Math.max(0, s.lives);
        return '❤️'.repeat(L) + '🖤'.repeat(Math.max(0, maxLives - L));
      })()
      : '';

  const timerText =
    s.timeLeftSec !== null && s.timeLeftSec !== undefined ? `⏱ ${s.timeLeftSec}s` : '';

  const levelText =
    s.currentLevel !== null && s.currentLevel !== undefined ? `${t('game.level')} ${s.currentLevel}` : '';

  const progressPct =
    s.levelProgress !== null && s.levelProgress !== undefined
      ? Math.round(Math.max(0, Math.min(1, s.levelProgress)) * 100)
      : 0;
  const showLevelProgress = s.gameMode !== 'ARCADE';

  return (
    <div id={d.root} className="leg-kick-ui" hidden={!s.hudVisible}>
      <header className="leg-kick-ui__header" aria-label={t('game.score')}>
        <div className="leg-kick-ui__lives">{hearts}</div>
        <div className="leg-kick-ui__center">
          {s.player1Score && <div className="leg-kick-ui__p1" hidden={!s.split}>
            P1 {s.player1Score ?? ''}
          </div>}
          {s.score && <div className="leg-kick-ui__score-block" hidden={s.split}>
            <span className="leg-kick-ui__score-label">{t('game.points')}</span>
            <span className="leg-kick-ui__score">{s.score}</span>
          </div>}
          {s.player2Score && <div className="leg-kick-ui__p2" hidden={!s.split}>
            P2 {s.player2Score ?? ''}
          </div>}
        </div>
        <div
          className={
            s.timerUrgent
              ? 'leg-kick-ui__timer leg-kick-ui__timer--urgent'
              : 'leg-kick-ui__timer'
          }
        >
          {timerText}
        </div>
      </header>
      <footer className="leg-kick-ui__footer">
        <span className="leg-kick-ui__mode">
          {s.gameMode !== null ? MODE_LABELS[s.gameMode] ?? s.gameMode : ''}
        </span>
        <span className="leg-kick-ui__level">{levelText}</span>
        {showLevelProgress ? (
          <div className="leg-kick-ui__progress" aria-hidden="true">
            <div
              className="leg-kick-ui__progress-fill"
              style={{ width: `${progressPct}%` }}
            />
          </div>
        ) : null}
        <span className="leg-kick-ui__streak">{s.streak > 0 ? `🔥 ×${s.streak}` : ''}</span>
        <span className="leg-kick-ui__combo">
          {s.comboCount !== null ? `COMBO ×${s.comboCount}` : ''}
        </span>
      </footer>
    </div>
  );
}
